<div
  class="h-48-px phx-web-color-background-bold-positive d-flex gap-12 align-items-center justify-center"
>
  <span
    class="phx-web-type-body-medium phx-web-color-content-on-inverted-emphasis ml-auto pl-24"
    [innerHTML]="content"
  ></span>
  <div class="d-flex align-items-center justify-center gap-8">
    <button
      *ngFor="let cta of CTAs"
      (click)="handleCTAClick(cta)"
      [class.ml-auto]="cta.action.is_primary"
      phx-button
      [phxButtonRole]="cta.action.is_primary ? 'primary' : 'secondary'"
      phxBackground="bold"
      phxSize="small"
    >{{ getCTAText(cta) }}
    </button>
  </div>
  <button
    (click)="closeBanner()"
    class="ml-auto mr-24"
    phx-icon-button
    phxIconButtonType="on-bold"
    phxIconButtonSize="small"
    [phxIcon]="crossIcon"
  ></button>
</div>